export enum AdCode {
	CODE_1 = "CODE_1",
	CODE_2 = "CODE_2",
	CODE_3 = "CODE_3",
	CODE_4 = "CODE_4",
	CODE_5 = "CODE_5",
	CODE_6 = "CODE_6",
}

export const AdCodeLabels: Record<AdCode, string> = {
	[AdCode.CODE_1]: "کد تبلیغ ۱",
	[AdCode.CODE_2]: "کد تبلیغ ۲",
	[AdCode.CODE_3]: "کد تبلیغ ۳",
	[AdCode.CODE_4]: "کد تبلیغ ۴",
	[AdCode.CODE_5]: "کد تبلیغ ۵",
	[AdCode.CODE_6]: "کد تبلیغ ۶",
};
